import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';

@Injectable({
  providedIn: 'root'
})
export class ApiintegrationsListenerService {

  @Output() apiIntegraionsListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.apiIntegraionsListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        });
  }
}
